export default __webpack_public_path__ + "9a58e197d337b1e9c2b0ab43ff7cba3c.png";